import { useFormField } from '@calendly/form'
import { HeadingText } from '@calendly/ui/components/typography'

import { ColorPicker } from './color_picker'
import { InputContainer } from './styles'

export const LockedEventType = () => {
  const [{ value: name }] = useFormField({ name: 'name' })

  return (
    <InputContainer disabled centered>
      <ColorPicker isLocked />
      <HeadingText level={2}>
        {name}
      </HeadingText>
    </InputContainer>
  )
}
